'use strict';

import Dashboard from './dashboard/dashboard.module';
import Login from './login/login.module';
import User from './user/user.module';
import Usuarios from './usuarios/usuarios.module';
import Proyectos from './proyectos/proyectos.module';
import RestablecerContrasenia from './restablecer_contrasenia/restablecer_contrasenia.module';

const Admin = angular
    .module('app.admin', [
        Dashboard,
        Login,
        User,
        Usuarios,
        Proyectos,
        RestablecerContrasenia
    ])
    .name;

export default Admin;



// WEBPACK FOOTER //
// ./src/app/components/admin/admin.module.js